<template>
  <div class="seasonal-main">
    <b-overlay :show="false" no-wrap />
    <CalendarVue class="seasonal-calendar" :saveData="saveData" :idCalendar="idCalendar"
      :callNewCalendar="callNewCalendar" @saved="switchSaving = $event"
      @refreshTableCalendar="refreshTableCalendar = $event" @selectNameCalendar="selectNameCalendar = $event"
      @backLastCalendar="backLastCalendar = $event" />

    <TableCalendar class="seasonal-grid-calendar" :refreshTableCalendar="refreshTableCalendar"
      :selectNameCalendar="selectNameCalendar" :backLastCalendar="backLastCalendar" :exportCalendars="exportingCalendar"
      :setBudgetCalendar="setBudgetCalendar" :openAccumulatedCalendar="openAccumulatedCalendar"
      :importCalendars="importingCalendar" :showHistory="showHistory" @setCalendar="idCalendar = $event" />

    <TableIndicator class="seasonal-grid-indicator" @refreshTableCalendar="refreshTableCalendar = $event"
      :idCalendar="idCalendar" />

    <div class="seasonal-footer">
      <section>
        <img src="@/assets/mostrarHistoricoAcoes.png" :alt="$t('calendar-history')" :title="$t('calendar-history')"
          @click="showCalendarsHistory" />
      </section>
      <section>

        <img v-if="enableBudgetBtn == true" src="@/assets/budgetCalendar.png" :alt="$t('define-budget-calendar')" :title="$t('define-budget-calendar')"
          @click="setBudget" />
        <img src="@/assets/export-base-calendar.png" :alt="$t('export-base-calendar')"
          :title="$t('export-base-calendar')" @click="exportBaseCalendar" />
        <img src="@/assets/export-calendar.png" :alt="$t('export-calendar')" :title="$t('export-calendar')"
          @click="exportCalendars" />
        <img src="@/assets/import-calendar.png" :alt="$t('import-calendar')" :title="$t('import-calendar')"
          @click="importCalendars" />
        <img src="@/assets/add-multiple-calendars.png" :alt="$t('add-acumulated-calendar')"
          :title="$t('add-acumulated-calendar')" @click="addAccumulatedCalendar" />

        <img src="@/assets/add-single-calendar.png" :title="$t('adicionar-novo-calendario')"
          :alt="$t('adicionar-novo-calendario')" @click="newCalendar" />

        <img src="@/assets/salvar.png" :alt="$t('save')" :title="$t('save')" @click="saveCalendar" />
      </section>
    </div>
  </div>
</template>

<script>
import SeasonalCalendarRepository from './service/SeasonalCalendarRepository';
import CalendarVue from './template/SeasonalCalendar.vue'
import TableCalendar from './template/TableCalendar.vue'
import TableIndicator from './template/TableIndicator.vue'
import * as XLSX from 'xlsx';
import { mapState } from "vuex";

export default {
  name: "SeasonalIndicator",
  components: { CalendarVue, TableCalendar, TableIndicator },
  computed: {
    ...mapState(["user"]),

    repositoryFullLoading() {
      return SeasonalCalendarRepository.fullLoading;
    }
  },
  data() {
    return {
      inputCalendar: false,
      saving: false,
      saveData: 0,
      idCalendar: -9999,
      callNewCalendar: 0,
      refreshTableCalendar: 0,
      selectNameCalendar: "",
      backLastCalendar: 0,
      switchSaving: 0,
      importingCalendar: 0,
      exportingCalendar: 0,
      showHistory: 0,
      enableBudgetBtn: false,
      setBudgetCalendar: 0,
      openAccumulatedCalendar: 0,
      fullLoading: SeasonalCalendarRepository.fullLoading,
    }
  },

  watch: {
    'repositoryFullLoading'(newValue) {
      this.fullLoading = newValue;
    },
    switchSaving() {
      this.saving = !this.saving
    }
  },

  methods: {
    exportBaseCalendar() {
      let baseCalendar = SeasonalCalendarRepository.GenerateBaseCalendar();
      let workbook = XLSX.utils.book_new();

      baseCalendar.forEach(sheet => {
        const worksheet = XLSX.utils.json_to_sheet(sheet.data);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name);
      });

      XLSX.writeFile(workbook, `Calendário_Base_${new Date().getFullYear()}.xlsx`);
    },

    importCalendars() {
      this.importingCalendar++;
    },

    exportCalendars() {
      this.exportingCalendar++;
    },

    showCalendarsHistory() {
      this.showHistory++;
    },

    newCalendar() {
      this.idCalendar = 0;
      this.callNewCalendar++;
    },

    saveCalendar() {
      this.saving = true;
      this.saveData++;
    },

    setBudget() {
      this.setBudgetCalendar++;
    },

    addAccumulatedCalendar() {
      this.openAccumulatedCalendar++;
    }
  },

  created() {
    if (this.user.Permissions && this.user.Permissions.definircalendariosazonalbudget &&
      this.user.Permissions.definircalendariosazonalbudget.allowed && this.user.Permissions.definircalendariosazonalbudget.allowed == true) {
      this.enableBudgetBtn = true;
    } else {
      this.enableBudgetBtn = false;
    }
  }
}
</script>

<style scoped>
.seasonal-main {
  display: grid;
  grid-template-rows: 33.5vh 33.5vh 7.5vh;
  grid-template-columns: 70% 30%;
}

.seasonal-calendar {
  grid-column: 1;
  grid-row-start: 1;
  grid-row-end: 3;
}

.seasonal-grid-calendar {
  grid-column: 2;
  grid-row-start: 2;
}

.seasonal-grid-indicator {
  grid-column: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  padding: 0px 0px 0px 5px;
}

.seasonal-footer {
  grid-column-start: 1;
  grid-column-end: 3;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  padding-top: 2rem;
}

.seasonal-footer img {
  width: 35px;
  margin: 0 1.2rem;
  cursor: pointer;
}

.setBudgetBtn {
  background-color: #FF7122;
  color: #fff;
  font-weight: 500;
  border-radius: 0.2rem;
  border: none;
  padding: 0.2rem 0.5rem;
  cursor: pointer;
}
</style>
